<template>
  <div
    :dir="$store.state.rightAlign ? 'rtl' : 'ltr'"
    :class="isPreview ? 'pb-2 mb-2' : 'bg-light p-3 pb-5 mb-2'"
  >
    <!-- menu buttons -->
    <MenuButtons
      v-if="!isPreview"
      :fieldData="fieldData"
      :collapse="collapse"
      :sectionIndex="sectionIndex"
      :fieldIndex="fieldIndex"
      :label="fieldData.label[selectedLanguage]"
      v-on:toggle-field="showSettings=!showSettings"
      v-on:collapse-field="collapse=!collapse"
    />

    <b-collapse
      class="card mt-5"
      id="collapse-1"
      v-show="JSON.parse(!fieldData.isHidden) || !isPreview"
      v-model="collapse"
    >
      <div :class="$store.state.rightAlign ? 'p-4 text-right' : 'p-4 text-left'" :id="fieldData.id">
        <div class="text-center" style="display: inline-flex;">
          <p v-if="JSON.parse(fieldData.uploadTitleTextIsDisabled) === 0">
            <span
              v-if="fieldData.validation && fieldData.validation.required == 1 "
              class="required-span"
            >*</span>
            {{(form1.enableSectionFieldEnumeration == 1 ? (sectionIndex+1)+'.'+(fieldIndex+1) :'')}} {{fieldData.label[selectedLanguage]}}
          </p>
        </div>
        <p
          v-if="JSON.parse(fieldData.uploadDescriptionTextIsDisabled) === 0"
          style="font: italic"
        >{{fieldData.fileDescription[selectedLanguage]}}</p>
        <span
          v-if="JSON.parse(fieldData.validation.required) && isFocus"
          class="text-danger"
        >{{fieldData.validationMessage[selectedLanguage]}}</span>
        <div :class="isDisabled == 1 ? 'isDisableUpload' : ''">
          <vue-dropzone
            v-if="taskStatus != 4"
            ref="myVueDropzone"
            @vdropzone-success="vsuccess"
            @vdropzone-error="verror"
            id="dropzone"
            :options="dropzoneOptions"
            v-on:vdropzone-sending="sendingEvent"
            :useCustomSlot="true"
            class="m-5 p-3"
            style="border:dashed 1px"
            type="file"
          >
            <div class="dropzone-custom-content">
              <h3 class="dropzone-custom-title">{{$t('upload.dragDrop')}}</h3>
              <div class="subtitle">{{$t('upload.dragDropContnt')}}</div>
            </div>
          </vue-dropzone>
        </div>
        <b-row>
          <b-col cols="12">
            <b-table-simple striped hover>
              <b-thead>
                <b-tr>
                  <b-th>{{$t('upload.fileName')}}</b-th>
                  <b-th>{{$t('upload.fileType')}}</b-th>
                  <b-th>{{$t('upload.fileSize')}}</b-th>
                  <b-th v-if="taskStatus != 4">{{$t('upload.fileAction')}}</b-th>
                </b-tr>
              </b-thead>
              <b-tbody v-for="(item, index) in files" :key="index">
                <b-tr>
                  <b-td>{{item.filename}}</b-td>
                  <b-td>{{item.type}}</b-td>
                  <b-td>{{item.size}}</b-td>
                  <b-td v-if="taskStatus != 4">
                    <b-button @click="onDeleteFile(index)" variant="danger" size="sm" class="mr-2" :disabled="isDisabled == 1 ? true : false">
                      <font-awesome-icon icon="trash" />
                    </b-button>
                    <b-button v-if="item.urlPath || item.url" @click="onDownloadFile(item)" variant="success" size="sm">
                      <font-awesome-icon icon="download" />
                    </b-button>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-col>
        </b-row>
      </div>

      <!-- show advance field options -->
      <b-modal
        ok-only
        ok-title="Close"
        @ok="onSaveData"
        size="lg"
        v-model="showSettings"
        scrollable
        title="Advanced Settings"
      >
        <AdvanceSettings
          :fieldData="fieldData"
          v-on:toggle-field="showSettings=!showSettings"
          :sectionIndex="sectionIndex"
          :fieldIndex="fieldIndex"
        />
      </b-modal>
    </b-collapse>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import AdvanceSettings from "../advanceHtmlSettingsCompenent.vue";
import MenuButtons from "../menuButtons";
//import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import VueDropzone from "../Dropzone/VueDropzone";
import { EventBus } from "@/event-bus.js";
import { Helper } from "../../helpers";
import { HTTP } from "../../utils/HTTP";
import axios from "axios";
import config from "../../configs/config";

export default {
  name: "UploadGroup",
  components: {
    AdvanceSettings,
    MenuButtons,
    VueDropzone,
  },
  data() {
    return {
      files: [],
      fields: ["filename", "type", "size", ""],
      isHidden: false,
      condition: {},
      showSettings: false,
      collapse: true,
      isFocus: false,
      isRequired: 0,
      fileTitle: null,
      fileDescription: null,
      taskStatus: 0,
      // dropzone options
      dropzoneOptions: {
        url: process.env.VUE_APP_API_URL + "v1/uploads/file/ddq",
        thumbnailWidth: 150,
        maxFilesize: 25,
        addRemoveLinks: true,
        acceptedFiles: this.fieldData.configuration.selectedFormats.join(),
        headers: {
          Authorization: "Bearer " + (this.$store.getters.accessToken || localStorage.getItem("accessToken")),
        },
        accept: (file, done) => {
          const name = file.name.toLowerCase();
          const dots = (name.match(/\./g) || []).length;

          if (dots !== 1) {
            this.$bvToast.toast(this.$t("upload.doubleExtensionMessage"), {
              title: this.$t("toast.title"),
              variant: "danger",
              autoHideDelay: 8000,
              solid: true
            });
            return done(this.$t("upload.invalidFileMessage"));
          }
          done();
        }
      },
    };
  },
  computed: {
    ...mapGetters(["form1", "selectedLanguage"]),
    ...mapState(["toggleAllCoppalse"]),
  },
  created() {
    EventBus.$on("onSubmitEndUserForm", (value) => {
      if (value == "progress" || this.fieldData.isHidden) {
        this.setDataToUser();
        this.$store.state.validFields = true;
        this.fieldData.isInValid = false;
      } else {
        if (
          this.fieldData.validation &&
          this.fieldData.validation.required == 1
        ) {
          if (this.files && this.files.length > 0) {
            this.$store.state.validFields = true;
            this.fieldData.isInValid = false;

            this.setDataToUser();
            // alert("submit success");
          } else {
            this.isFocus = true;
            this.$store.state.validFields = false;
            this.fieldData.isInValid = true;

            // alert("file required");
          }
        } else {
          this.setDataToUser();
        }
      }
    });

    EventBus.$on("OnInvalidFieldCatch", (inValidData) => {
      // // console.log("OnInvalidFieldCatch radio", inValidData, this.fieldData.id)
      document
        .getElementById(inValidData.elementId)
        .scrollIntoView({ behavior: "smooth" });
    });
  },

  mounted() {
    this.isRequired = this.fieldData.validation.required;
    this.checkForConditional();
    if (
      this.$route.name == "userform" ||
      this.$route.name == "EmployeeUserFormPage" ||
      this.$route.name == "EmployeeComplaintFormPage" ||
      this.$route.name == "ViewComplaints"
    ) {
      this.setDataFromUser();
    }
    let st = parseInt(localStorage.getItem("activeTaskStatus"));
    this.taskStatus = st;
  },

  watch: {
    toggleAllCoppalse(vlue) {
      this.collapse = vlue;
    },
  },

  methods: {
    setDataFromUser() {
      // console.log("------setFieldValue----------");
      this.$store.state.getUserFormSubmitArray.length &&
        this.$store.state.getUserFormSubmitArray.map((a, index) => {
          if (a.elementId === this.fieldData.id) {
            a.elements.map((el) => {
              // console.log("el", el);
              return (
                (this.files = el.postValue || null),
                (this.fieldData.isHidden = el.postValue.length ? false : true)
              );
            });
          }
        });
    },

    readableBytes(bytes) {
      var i = Math.floor(Math.log(bytes) / Math.log(1024)),
        sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

      return (bytes / Math.pow(1024, i)).toFixed(2) * 1 + " " + sizes[i];
    },

    verror(file, message, xhr) {
      // // console.log("message", message)
      Helper.makeToast(
        this.$bvToast,
        "danger",
        this.$t("validations.invalidFormat"),
        this.$t("toast.title"),
      );
      this.$refs.myVueDropzone.removeFile(file);
    },

    vsuccess(file, response) {
      const name = file.name.toLowerCase();
      const dots = (name.match(/\./g) || []).length;
      let responseJson = "";
      if (typeof response === "string") {
        responseJson = JSON.parse(response);
      }
      if (responseJson.error == true || responseJson.error == "true") {
        let errorMessage = responseJson.message
          ? responseJson.message
          : this.$t("upload.invalidFileMessage");
        Helper.makeToast(
          this.$bvToast,
          "danger",
          errorMessage
        );
        this.$refs.myVueDropzone.removeFile(file);
        return;
      } else if (dots !== 1) {
        Helper.makeToast(
          this.$bvToast,
          "danger",
          this.$t("upload.doubleExtensionMessage")
        );
        this.$refs.myVueDropzone.removeFile(file);
      } else if (response && response.error === true) {
        Helper.makeToast(
          this.$bvToast,
          "danger",
          response.message
        );
        this.$refs.myVueDropzone.removeFile(file);
      } else {
        const registerData = _.clone(this.$store.state.registerData);
        registerData[this.fieldData.id] = file.name;
        this.$store.state.registerData = registerData;

        this.isFocus = false;
        this.$store.state.validFields = true;
        this.fieldData.isInValid = false;

        // main calculations :p
        const numkeys = Object.keys(registerData).length;
        // const sectionLength = this.form1.formSection.length > 1 ? this.form1.formSection[this.sectionIndex].formElements.length : 1
        this.$store.state.progressValue = numkeys;

        let uploadedFile = {
          filename: file.name,
          size: file.size,
          type: file.type,
          actions: "&nbsp;",
          url: response.url || null,
          urlPath: response.urlPath || (response.url || null),
          fileId: response.fileId || null,
        };
        this.files.push(uploadedFile);
        this.$refs.myVueDropzone.removeFile(file);
      }
    },
    async onDownloadFile ( data ) {
      let titleForm = data.filename;
      axios( {
        url: config.API_URL + "v1/download/file",
        method: "POST",
        responseType: "blob", // important
        headers: {
          Authorization: "Bearer " + localStorage.getItem( "accessToken" ),
        },
        data: data,
      } )
        .then( ( response ) => {
          if ( window.navigator.msSaveOrOpenBlob ) {
            let blob = new Blob( [response.data] );
            // IE11
            window.navigator.msSaveOrOpenBlob( blob, titleForm );
            Helper.makeToast(
              this.$bvToast,
              "success",
              "File has been download successfully"
            );
            return;
          } else {
            const url = window.URL.createObjectURL( new Blob( [response.data] ) );
            const link = document.createElement( "a" );
            link.href = url;
            link.setAttribute( "download", titleForm ); //or any other extension
            document.body.appendChild( link );
            link.click();
            if ( response ) {
              Helper.makeToast(
                this.$bvToast,
                "success",
                "File has been download successfully"
              );
            }
          }
        } )
        .catch( ( error ) => {
          Helper.makeToast( this.$bvToast, "danger", "Unable to download file." );
          return [error];
        } );
    },
    onDeleteFile(index) {
      // const registerData = _.clone(this.$store.state.registerData);
      // if (this.files.length) {
      //   // delete registerData[this.fieldData.id];
      //   this.$store.state.registerData = registerData;

      //   const numkeys = Object.keys(registerData).length;
      //   // const sectionLength = this.form1.formSection.length > 1 ? this.form1.formSection[this.sectionIndex].formElements.length : 1
      //   this.$store.state.progressValue = numkeys;
      // }
      console.log("onDeleteFile", this.files[index]);
      this.onDeleteApi(this.files[index], index);
    },

    async onDeleteApi(file, index) {
      // console.log("onDeleteApi", file)
      if (file && file.fileId) {
        let token = "Bearer " + localStorage.getItem("accessToken");
        let userId = localStorage.getItem("userId");
        let taskId = localStorage.getItem("taskId");
        let result = await HTTP(
          "post",
          "v1/thirdparty/delete_document",
          {
            doc_delete_type: "ddq-form",
            doc_id: file.fileId,
            third_party_id: 0,
            company_id: 0,
            user_id: userId,
          },
          {
            Authorization: "Bearer " + (this.$store.getters.accessToken || localStorage.getItem("accessToken")),
          },
          null,
          false
        );
        if (result.data) {
          this.files.splice(index, 1);
        }
        // // console.log("result delete upload api", result);
      }
    },

    onSaveData() {
      EventBus.$emit("onSaveSettings", "saving settings");
      Helper.makeToast(this.$bvToast, "success", "Settings Updated");
    },

    setDataToUser(e) {
      if (
        this.$route.name == "userform" ||
        this.$route.name == "EmployeeUserFormPage" ||
        this.$route.name == "EmployeeComplaintFormPage" ||
        this.$route.name == "ViewComplaints"
      ) {
        this.name = e;
        this.$store.state.userFormSubmitArray.map((a, index) => {
          if (a.elementId === this.fieldData.id) {
            // // console.log("found");
            if (this.files.length) {
              a.elements[0] = {
                postValue: this.files,
                postName: "file",
              };
            } else {
              a.elements = [];
            }
          }
        });
      }
    },

    checkForConditional() {
      // // console.log("checkForConditional", this.fieldData)
      if (this.fieldData.isConditional == 1) {
        this.fieldData.isHidden = true;
      }
    },

    /**
     * dropzone js send additional params
     */
    sendingEvent(file, xhr, formData) {
      formData.append("formId", this.form1.formId);
      formData.append("fieldId", this.fieldData.id);
      formData.append("fieldIndex", this.fieldIndex);
      formData.append("sectionIndex", this.fieldIndex);
      formData.append("sectionId", this.fieldIndex);
      formData.append("taskId", localStorage.getItem("taskId"));
    },
  },
  props: {
    fieldData: Object,
    isPreview: Boolean,
    sectionIndex: Number,
    fieldIndex: Number,
    isDisabled: Number,
  },
};
</script>

<style>
.required-span {
  font-size: 24px;
  margin-left: 3px;
  color: red;
}
.isDisableUpload {
  pointer-events: none;
}
</style>
